import getRecommendPremiumToStandardUrlQueryParameters from '@atlassian/jira-relay/src/__generated__/RecommendPremiumToStandardModalRendererQuery$parameters';
import type { RecommendPremiumToStandardModalRendererQuery$variables } from '@atlassian/jira-relay/src/__generated__/RecommendPremiumToStandardModalRendererQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = RecommendPremiumToStandardModalRendererQuery$variables;
export const recommendPremiumToStandardModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(async () =>
		import(
			/* webpackChunkName: "async-recommend-premium-to-standard-modal" */ './src/ui/RecommendPremiumToStandardModalRenderer.tsx'
		).then(
			({ RecommendPremiumToStandardModalRenderer }) => RecommendPremiumToStandardModalRenderer,
		),
	),
	getPreloadProps: ({ cloudIds, isTwcJiraTouchPointFix }: EntryPointParams) => ({
		queries: {
			getRecommendPremiumToStandardUrlQuery: {
				parameters: getRecommendPremiumToStandardUrlQueryParameters,
				variables: {
					cloudIds,
					isTwcJiraTouchPointFix,
				},
			},
		},
	}),
});
